import { useRouter } from 'next/router';

import { useCallback } from 'react';

const INITIAL_ROUTE_STORAGE_KEY = '@auth/initialRoute';

export function removeInitialRoute() {
  return localStorage.removeItem(INITIAL_ROUTE_STORAGE_KEY);
}

export function getInitialRoute() {
  return localStorage.getItem(INITIAL_ROUTE_STORAGE_KEY);
}

/**
 * Redirects to the route you originally opened before the login
 */
export function useStoreInitialRoute() {
  const { asPath } = useRouter();

  return useCallback(() => {
    localStorage.setItem(INITIAL_ROUTE_STORAGE_KEY, asPath);
  }, [asPath]);
}
